import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from '@cotyorg/ccx-atoms/Link';
import Icon from '@cotyorg/ccx-atoms/Icon';

// istanbul ignore next
const IconLink = ({
  children,
  link,
  anchor,
  iconSrc,
  iconAlt = '',
  size,
  style,
  textInside,
  extraClass,
  iconExtraClass,
  iconAfterText,
  textExtraClass,
  onClick,
  testAttribute,
  iconWidth,
  iconHeight,
}) => {
  const iconLinkCssClass = classNames('icon-link', {
    [`icon-link--${style}`]: style,
    [`${extraClass}`]: extraClass,
  });

  const textCssClass = classNames('icon-link__text', {
    'icon-link__text--inside': textInside,
    [`${textExtraClass}`]: textExtraClass,
  });

  const IconEl = (<Icon
    iconSrc={iconSrc}
    alt={iconAlt}
    size={size}
    iconExtraClass={iconExtraClass}
    width={iconWidth}
    height={iconHeight}
  />);

  return (
    <Link
      link={link}
      anchor={anchor}
      extraClass={iconLinkCssClass}
      onClick={onClick}
      testAttribute={testAttribute}
    >
      {iconSrc && !iconAfterText && IconEl}
      {children && <span className={textCssClass}>{children}</span>}
      {iconSrc && iconAfterText && IconEl}
    </Link>
  );
};

IconLink.propTypes = {
  children: PropTypes.node,
  link: PropTypes.string,
  anchor: PropTypes.string,
  iconSrc: PropTypes.string.isRequired,
  iconAlt: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  style: PropTypes.string,
  textInside: PropTypes.bool,
  extraClass: PropTypes.string,
  iconExtraClass: PropTypes.string,
  iconAfterText: PropTypes.bool,
  textExtraClass: PropTypes.string,
  onClick: PropTypes.func,
  testAttribute: PropTypes.string,
  iconWidth: PropTypes.number,
  iconHeight: PropTypes.number,
};

export default IconLink;
